import SearchInputWithState from './search_input_with_state';

export { SearchInputWithState };
export default SearchInputWithState;
